import { estInstallee, estIOS } from '../../pwa/register'
import { Carte, Encart, Entete } from '../composants'

export function PageInstallation() {
  const installee = estInstallee()
  return (
    <>
      <Entete titre="Installation" retour />
      <main className="contenu">
        {installee ? (
          <Encart ton="ok">L’application est installée sur cet appareil.</Encart>
        ) : (
          <Encart ton="alerte">
            Laissée dans un onglet de Safari, l’application peut voir ses données purgées après quelques semaines sans visite. Installée
            sur l’écran d’accueil, elle les conserve durablement.
          </Encart>
        )}

        <Carte titre={estIOS() ? 'Sur iPhone' : 'Sur iPhone ou iPad'}>
          <ol className="etapes">
            <li className="etape"><span>Ouvrir cette adresse dans <strong>Safari</strong> (pas dans une autre app).</span></li>
            <li className="etape"><span>Toucher le bouton <strong>Partager</strong>, puis <strong>Sur l’écran d’accueil</strong>.</span></li>
            <li className="etape"><span>Lancer <strong>Budget</strong> depuis sa nouvelle icône : c’est cette version qui garde les données.</span></li>
          </ol>
        </Carte>

        <Carte titre="Hors ligne et confidentialité">
          <p className="doux">
            Tout fonctionne sans réseau. Les montants, les factures et les justificatifs restent sur l’appareil : aucun serveur ne les
            reçoit. La contrepartie est qu’une perte du téléphone emporte les données — d’où l’export régulier depuis Réglages.
          </p>
        </Carte>
      </main>
    </>
  )
}
